<template>
  <div class="sign-in-success-phone-update">
    <ModalTitle v-if="result">
      {{ result }}
    </ModalTitle>
  </div>
</template>

<script>
import ModalTitle from '@components/modals/Parts/ModalTitle.vue';

export default {
  name: 'SignInSuccessPhoneUpdate',
  components: { ModalTitle },
  props: ['result', 'messages'],
  beforeUnmount() {
    location.reload();
  },
};
</script>

<style lang="scss" scoped>
.sign-in-success-phone-update {
}
</style>
